























import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import EntityType from '@/models/Shared/EntityType';
import ProductSubType from '@/models/Products/ProductSubType';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import { ProductIssueDetailsModule } from '@/store/Products/ProductIssueDetailsModule';
import DefaultSettingsTabs from '@/components/Products/ProductSettings/DefaultSettings/DefaultSettingsTabs.vue';
import SecondaryWalletsTabs from '@/components/Products/ProductSettings/SecondaryWallets/SecondaryWalletsTabs.vue';

@Component({ name: 'ProductSettingsTabs', components: { DefaultSettingsTabs, SecondaryWalletsTabs } })
export default class extends SaascadaVue {

    EntityType = EntityType;

    @Prop({required: true})
    entityType: EntityType;

    tabIndex = 0;

    get product() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.product;
        }
        return ProductIssueDetailsModule.productIssue;
    }

    get productAllowsSecondaryWalletSettings() {
        // Only the deposit current account product allows secondary wallets
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.product.generalSettings.subType === ProductSubType.DepositCurrentAccount;
        }
        return ProductIssueDetailsModule.productIssue.generalSettings.subType === ProductSubType.DepositCurrentAccount;
    }

}
